import React from "react";

const Eye = () => {
  return (
    <svg fill="none" viewBox="0 0 24 24">
      <path fill="#000" fill-rule="evenodd" d="M12.0008 5.25c-4.30743 0-7.96431 2.79374-9.25378 6.6702-.01779.0534-.01777.1116.00005.165C4.03815 15.9589 7.69362 18.75 11.9991 18.75c4.3074 0 7.9643-2.7937 9.2537-6.6702.0178-.0534.0178-.1116 0-.165-1.2911-3.87367-4.9466-6.6648-9.252-6.6648ZM1.3237 11.4467C2.81095 6.97571 7.0282 3.75 12.0008 3.75c4.9703 0 9.1859 3.22271 10.675 7.6905.1204.361.1205.7517.0004 1.1128-1.4873 4.471-5.7045 7.6967-10.6771 7.6967-4.97034 0-9.18597-3.2227-10.67507-7.6905-.12034-.361-.12046-.7517-.00033-1.1128ZM12 9.75c-1.2426 0-2.25 1.0074-2.25 2.25s1.0074 2.25 2.25 2.25 2.25-1.0074 2.25-2.25S13.2426 9.75 12 9.75ZM8.25 12c0-2.07107 1.67893-3.75 3.75-3.75 2.0711 0 3.75 1.67893 3.75 3.75 0 2.0711-1.6789 3.75-3.75 3.75-2.07107 0-3.75-1.6789-3.75-3.75Z" clip-rule="evenodd"/>
    </svg>
  );
};

export default Eye; 